import { render, staticRenderFns } from "./ClassManagement.pug?vue&type=template&id=dab01b08&lang=pug&"
import script from "./ClassManagement.ts?vue&type=script&lang=ts&"
export * from "./ClassManagement.ts?vue&type=script&lang=ts&"
import style0 from "./ClassManagement.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports